import { AVAILABILITY_TOGGLE, DESKTOP_OPEN_BROWSER, GLOBAL_SEARCH_FORM_FOCUSED } from 'constants/Header';

export const openHelpDesktop = (url) => {
  return {
    type: DESKTOP_OPEN_BROWSER,
    payload: { url }
  };
};

export function toggleAvailability() {
  return {
    type: AVAILABILITY_TOGGLE
  };
}

export function setFormFocus(isFocused) {
  return {
    type: GLOBAL_SEARCH_FORM_FOCUSED,
    payload: isFocused
  };
}

export default {
  openHelpDesktop,
  setFormFocus,
  toggleAvailability
};
